import { render } from "./welcome-page.vue?vue&type=template&id=8b6ca356&scoped=true"
import script from "./welcome-page.vue?vue&type=script&lang=js"
export * from "./welcome-page.vue?vue&type=script&lang=js"

import "./welcome-page.vue?vue&type=style&index=0&id=8b6ca356&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6ca356"]])

export default __exports__